import { gql } from '@apollo/client';

export const SETUP_SENDBIRD_CHAT = gql`
  mutation SetupSendbirdChat(
    $currentUserId: String!
    $currentNickname: String!
    $currentProfileUrl: String
    $candidateUserId: String!
    $candidateNickname: String!
    $candidateProfileUrl: String
  ) {
    setupSendbirdChat(
      currentUserId: $currentUserId
      currentNickname: $currentNickname
      currentProfileUrl: $currentProfileUrl
      candidateUserId: $candidateUserId
      candidateNickname: $candidateNickname
      candidateProfileUrl: $candidateProfileUrl
    ) {
      user {
        userId
        nickname
        profileUrl
        accessToken
        appId
      }
      channel {
        channelUrl
        appId
      }
    }
  }
`;

 export const GET_SENDBIRD_INIT_DATA = gql`
  query SendbirdInitData {
    sendbirdInitData {
      accessToken
      appId
      directChannels {
        userId
        nickname
        profileUrl
      }
    }
  }
`;